"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.rgbValue = void 0;
var rgbValue = function (v) { return v; };
exports.rgbValue = rgbValue;
